import React, { Component, useContext } from 'react';
import { FormGroup, FormControl, Input } from 'components';
import { SortableContainer } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import RandomText from './RandomText';
import OrderNote from './OrderNote';
import CheckoutButton from './CheckoutButton';
import Module from './Module';
import { RESET_EXTRA_MODULE, SET_ITEM } from 'reducers/CampaignReducer';
import { NEW_CAMPAIGN_INITIAL_STATE } from 'lib/globals';
import ShopContext from 'context/ShopContext';

const ExtraModules = ({ context, label = 'Extra Modules', hasCheckout = true }) => {
	const {
		state: {
			settings: {
				theme: { primary, secondary, background },
				font,
				modules: { checkout_button },
			},
		},
	} = useContext(ShopContext);
	const modules = context.state.settings.modules;
	const onSortEnd = ({ oldIndex, newIndex }) => {
		const newOrder = arrayMove(modules.order, oldIndex, newIndex);
		// this.props.edit('modules', 'order', newOrder);
		context.dispatch({
			type: SET_ITEM,
			path: 'settings.modules.order',
			value: newOrder,
		});
	};
	const resetModule = (module) => {
		context.dispatch({
			type: SET_ITEM,
			path: `settings.modules.${module}`,
			value: NEW_CAMPAIGN_INITIAL_STATE({
				checkout_button,
				primary,
				secondary,
				font_color: font.color,
				background,
			}).settings.modules[module],
		});
	};
	return <ModulesList useDragHandle {...{ context, modules, onSortEnd, resetModule, label, hasCheckout }} />;
};

const ModulesList = SortableContainer(({ context, resetModule, modules, label, hasCheckout }) => {
	return (
		<FormGroup label={label} info="Move around and edit extra modules. More modules coming soon...">
			<div>
				{modules.order.map((key, index) => {
					switch (key) {
						case 'random_text':
							return (
								<RandomText
									key={key}
									{...{
										context,
										index,
										moduleKey: key,
										module: modules[key],
										resetModule,
									}}
								/>
							);
						case 'checkout_button':
							return (
								<Module
									name="Checkout Section"
									key={key}
									{...{
										context,
										index,
										switchButton: false,
										moduleKey: key,
										module: modules[key],
										resetModule,
										hasCheckout,
										reset: false,
									}}
								/>
							);
						case 'order_note':
							return (
								<OrderNote
									name="Order's Note Section"
									key={key}
									{...{
										context,
										index,
										switchButton: true,
										moduleKey: key,
										module: modules[key],
										resetModule,
									}}
								/>
							);
						default:
							return null;
					}
				})}
			</div>
		</FormGroup>
	);
});

export default ExtraModules;
